import { statesNG } from "@/data";

export const getNigerianStates = () => statesNG;
